
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Gruppe 130","xmlns":"http://www.w3.org/2000/svg","width":"27.332","height":"27.332"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Pfad 93","d":"M14.912 6.212a.622.622 0 01-.621-.621c0-2.4-1.672-4.349-3.72-4.349-2.057 0-3.73 1.954-3.726 4.348a.622.622 0 01-.621.622.62.62 0 01-.621-.621C5.603 2.512 7.827.004 10.57 0h.006c2.732 0 4.958 2.506 4.962 5.59a.621.621 0 01-.62.622z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Pfad 94","d":"M21.122 27.332H.622a.628.628 0 01-.461-.209.62.62 0 01-.157-.478L1.875 8.014a.622.622 0 01.619-.559h16.145a.62.62 0 01.619.569l.627 7.454a.62.62 0 01-.567.671.613.613 0 01-.671-.566l-.58-6.885H3.054L1.307 26.091h19.815a.621.621 0 010 1.242z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Pfad 95","d":"M26.71 27.332H13.049a.62.62 0 01-.617-.69l1.242-11.181a.621.621 0 01.617-.553h11.178a.62.62 0 01.616.553l1.242 11.181a.62.62 0 01-.617.69zM13.743 26.09h12.273l-1.1-9.939H14.848z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Pfad 96","d":"M19.876 22.362c-2.049 0-3.718-1.949-3.722-4.347a.62.62 0 01.62-.622.622.622 0 01.621.62c0 1.714 1.115 3.107 2.48 3.107a2.246 2.246 0 001.721-.869 3.47 3.47 0 00.764-2.236.622.622 0 01.62-.622.62.62 0 01.621.62 4.723 4.723 0 01-1.052 3.033 3.47 3.47 0 01-2.673 1.316z","fill":"#fff"}})])
          )
        }
      }
    